import React, { useEffect, useRef, useState } from 'react';
import './Preloader.css';

function getHeaderLogoElement() {
  const candidates = [
    document.getElementById('litaana-header-logo-mobile'),
    document.getElementById('litaana-header-logo'),
  ];

  for (const el of candidates) {
    if (!el) continue;
    const rect = el.getBoundingClientRect();
    if (rect.width > 0 && rect.height > 0) {
      return el;
    }
  }

  return null;
}

export default function Preloader({ fadeOut }) {
  const [logoError, setLogoError] = useState(false);
  const [flyStyle, setFlyStyle] = useState(null);
  const [flyActive, setFlyActive] = useState(false);
  const logoRef = useRef(null);
  const flyStarted = useRef(false);

  useEffect(() => {
    if (!fadeOut || flyStarted.current) {
      return undefined;
    }

    flyStarted.current = true;
    const logoEl = logoRef.current;
    const headerLogo = getHeaderLogoElement();

    if (!logoEl || !headerLogo) {
      return undefined;
    }

    const from = logoEl.getBoundingClientRect();
    const to = headerLogo.getBoundingClientRect();

    if (!from.width || !to.width) {
      return undefined;
    }

    const scale = to.width / from.width;
    const translateX = to.left + to.width / 2 - (from.left + from.width / 2);
    const translateY = to.top + to.height / 2 - (from.top + from.height / 2);

    setFlyActive(true);
    setFlyStyle({ transform: 'translate(0, 0) scale(1)' });

    let frame2;
    const frame1 = requestAnimationFrame(() => {
      frame2 = requestAnimationFrame(() => {
        setFlyStyle({
          transform: `translate(${translateX}px, ${translateY}px) scale(${scale})`,
        });
      });
    });

    return () => {
      cancelAnimationFrame(frame1);
      if (frame2) {
        cancelAnimationFrame(frame2);
      }
    };
  }, [fadeOut]);

  useEffect(() => {
    if (!fadeOut) {
      flyStarted.current = false;
      setFlyActive(false);
      setFlyStyle(null);
    }
  }, [fadeOut]);

  const preloaderClassName = [
    'preloader',
    fadeOut ? 'preloader--fade-out' : '',
    flyActive ? 'preloader--fly-out' : '',
  ]
    .filter(Boolean)
    .join(' ');

  return (
    <div className={preloaderClassName} role="status" aria-label="Loading LITAANA">
      <div className="preloader__backdrop">
        <div className="preloader__gradient" />
        <div className="preloader__orb preloader__orb--1" />
        <div className="preloader__orb preloader__orb--2" />
        <div className="preloader__orb preloader__orb--3" />
        <div className="preloader__shine" />
      </div>

      <div className="preloader__top-bar" />

      <div className="preloader__panel">
        <div className="preloader__logo-card">
          <div className="preloader__brand">
            {!logoError ? (
              <img
                ref={logoRef}
                src="images/newlogo.png"
                alt="LITAANA"
                className={`preloader__logo preloader__logo-fly${flyActive ? ' preloader__logo-fly--active' : ''}`}
                style={flyActive ? flyStyle : undefined}
                onError={() => setLogoError(true)}
              />
            ) : (
              <h1 className="preloader__logo-text">LITAANA</h1>
            )}
          </div>
        </div>

        <p className="preloader__tagline">
          Laxminarayan Institute Alumni Association
        </p>

        <div className="preloader__progress">
          <div className="preloader__progress-track">
            <div className="preloader__progress-bar" />
          </div>
        </div>

        <div className="preloader__dots" aria-hidden="true">
          <span />
          <span />
          <span />
        </div>
      </div>
    </div>
  );
}
